module.exports = __webpack_public_path__ + "img/youtube.9a1e5fd4.svg";